import { Component, OnInit, Input } from '@angular/core';
import { Topic } from '../topic'
import { FilterService } from '../filter.service'

@Component({
  selector: 'app-topic-filter',
  templateUrl: './topic-filter.component.html',
  styleUrls: ['./topic-filter.component.css']
})
export class TopicFilterComponent implements OnInit {
  @Input() topic: Topic

  constructor(
    private fs: FilterService
  ) { }

  ngOnInit() {
  }

  get label() {
    return this.topic.title
  }

  switch(event) {
    this.fs.setTopicFilter(this.topic)
  }

  get isSelected() {
    return this.fs.isSelectedTopic(this.topic)
  }

}



// WEBPACK FOOTER //
// ./src/app/topic-filter/topic-filter.component.ts